import { SizeLocale } from "../../../api/gql/graphql";
import { CurrentView } from "../../../types/types";

export const getStartView = (hasRecommendation: boolean): CurrentView => {
  return hasRecommendation ? CurrentView.Result : CurrentView.Intro;
};

export const formatSizeLocale = (sizeLocale: SizeLocale): string => {
  let sl = sizeLocale.replace(/_/g, " ");
  if (sizeLocale === SizeLocale.Mondopoint) {
    sl = "MP";
  }
  return sl;
};
